export default function FormatText(t) {
    return t.replace('&', '').replace(' a ', '').replace(/\s/g, '');
}
